import axios from "../config/axios";

function getOrCreateId(key) {
  const existing = window.localStorage.getItem(key);
  if (existing) return existing;
  const value = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  window.localStorage.setItem(key, value);
  return value;
}

function getDeviceType() {
  const ua = (navigator.userAgent || "").toLowerCase();
  if (/tablet|ipad/.test(ua)) return "tablet";
  if (/mobi|android|iphone/.test(ua)) return "mobile";
  return "desktop";
}

function getUtm() {
  const params = new URLSearchParams(window.location.search || "");
  return {
    source: params.get("utm_source") || "",
    medium: params.get("utm_medium") || "",
    campaign: params.get("utm_campaign") || "",
    term: params.get("utm_term") || "",
    content: params.get("utm_content") || "",
  };
}

export async function trackSellerPageView(payload) {
  try {
    if (!payload?.sellerId) return;
    const visitorId = getOrCreateId("yinn_visitor_id");
    const sessionId = getOrCreateId("yinn_session_id");
    await axios.post("/analytics/track", {
      eventType: "page_view",
      visitorId,
      sessionId,
      pagePath: `${window.location.pathname}${window.location.search || ""}`,
      referrer: document.referrer || "",
      deviceType: getDeviceType(),
      utm: getUtm(),
      ...payload,
    });
  } catch (e) {
    // analytics should never block user flows
  }
}
